import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getCountries } from "../../../REDUX/actions/country";
import { getCurrentProspect } from "../../../REDUX/actions/prospects";
import NewAdressCard from "./Address/NewAdressCard";
import AddAdress from "./Address/AddAdress";

function Adresses({ initialValues, handleFormChange }) {
  const dispatch = useDispatch();

  const { countries } = useSelector((state) => state.countryReducer);
  const [formData, setFormData] = useState(initialValues?.delivery);
  const [secondFormData, setSecondFormData] = useState(initialValues?.billing);
  const [fetchedData, setFetchedData] = useState({});

  const { currentProspect } = useSelector((state) => state?.prospectsReducer);

  useEffect(() => {
    setFetchedData((fetchedData) => ({ ...fetchedData, country: countries }));
  }, [countries]);

  useEffect(() => {
    const controller = new AbortController();
    dispatch(getCountries(false, controller.signal));

    return () => controller.abort();
  }, [dispatch]);

  useEffect(() => {
    handleFormChange("addresses", {
      delivery: formData,
      billing: secondFormData,
    });
  }, [formData, secondFormData]);

  return (
    <div className="flex-1 d-flex flex-column p-5">
      <div className="flex-1 d-flex flex-wrap gap-5">
        {currentProspect?.attributes?.deliveryAddresses?.data?.map(
          (address) => (
            <NewAdressCard
              key={address.id}
              address={address}
              type="addresseDeLivraison"
              prospectId={currentProspect?.id}
              withSelectOption={false}
              callBack={() => dispatch(getCurrentProspect(currentProspect?.id))}
            />
          ),
        )}
        <AddAdress
          prospectId={currentProspect?.id}
          type="addresseDeLivraison"
          callBack={() => dispatch(getCurrentProspect(currentProspect?.id))}
        />
      </div>
      <hr style={{ borderColor: "#abb8b2", margin: 0 }} className={"my-5"} />

      <div className="flex-1 d-flex flex-wrap gap-5">
        {currentProspect?.attributes?.billingAddresses?.data?.map((address) => (
          <NewAdressCard
            key={address.id}
            address={address}
            type="addresseDeFacturation"
            prospectId={currentProspect?.id}
            withSelectOption={false}
            callBack={() => dispatch(getCurrentProspect(currentProspect?.id))}
          />
        ))}
        <AddAdress
          prospectId={currentProspect?.id}
          type="addresseDeFacturation"
          callBack={() => dispatch(getCurrentProspect(currentProspect?.id))}
        />
      </div>
    </div>
  );
}

export default Adresses;
